import { Controller } from "@hotwired/stimulus";

// Handles the "All day" checkbox toggle for calendar blocks
// When checked, shows a single date field and sets times to full day
// When unchecked, shows separate datetime fields
export default class extends Controller {
  static targets = ["checkbox", "dateTimeFields", "dateField", "startTime", "endTime", "date"];

  connect() {
    this.toggleFields();
  }

  toggle() {
    this.toggleFields();
  }

  toggleFields() {
    const isAllDay = this.checkboxTarget.checked;

    if (isAllDay) {
      // Hide datetime fields, show date-only field
      this.dateTimeFieldsTarget.classList.add("hidden");
      this.dateFieldTarget.classList.remove("hidden");

      // Extract date from start_time and set it
      if (this.startTimeTarget.value) {
        const dateValue = this.startTimeTarget.value.split("T")[0];
        this.dateTarget.value = dateValue;
      }
    } else {
      // Show datetime fields, hide date-only field
      this.dateTimeFieldsTarget.classList.remove("hidden");
      this.dateFieldTarget.classList.add("hidden");
    }
  }

  // Before form submit, set proper times if all_day is checked
  setAllDayTimes(event) {
    if (this.checkboxTarget.checked && this.dateTarget.value) {
      const selectedDate = this.dateTarget.value;
      // Set start_time to beginning of day (00:00)
      this.startTimeTarget.value = `${selectedDate}T00:00`;
      // Set end_time to end of day (23:59)
      this.endTimeTarget.value = `${selectedDate}T23:59`;
    }
  }
}
